import { HttpClient } from 'api/http-client';
import { Field } from 'api/tasks';
import { Color } from 'components/colors';

export type FieldMetaDataOption = {
  color: Color;
  label: string;
  position?: number;
  group?: number;
  deletable?: boolean;
  editable?: boolean;
};

export type RatingFieldScale = 3 | 5 | 7 | 10;
export const RATING_SCALE = [3, 5, 7, 10];

export type RatingFieldMeta = {
  options: FieldMetaDataOption[];
  ratingScale?: number;
};

export interface SingleAndMultiSelectFieldMeta {
  options: FieldMetaDataOption[];
}

export type KeyEventMeta = {
  captureKeyIntervalForFirstActivityOnly: boolean;
  allowAdminsAndOwnersToEdit: boolean;
};

export type IntervalMeta = {
  startKeyEventId: number;
  endKeyEventId: number;
  intervalBenchmark: number;
};

export type FieldMetaData =
  | RatingFieldMeta
  | KeyEventMeta
  | IntervalMeta
  | SingleAndMultiSelectFieldMeta;

interface Payload
  extends Pick<
    Field,
    | 'isEnabled'
    | 'fieldLabel'
    | 'description'
    | 'private'
    | 'fieldDataType'
    | 'fieldType'
    | 'objectType'
    | 'fieldSectionId'
  > {
  metaData?: FieldMetaData;
}
export type FieldPayload = Partial<Payload>;

function getUrl(fieldId: number) {
  return `/fields/${fieldId}`;
}

class FieldsHttpClient extends HttpClient {
  public getAllFields = async () => this.get<Field[]>('/fields');

  public async updateField(
    fieldId: number,
    data: FieldPayload,
  ): Promise<Field> {
    return this.put(getUrl(fieldId), data);
  }

  public async deleteField(fieldId: number): Promise<Field> {
    return this.delete(getUrl(fieldId));
  }

  public async createField(data: FieldPayload): Promise<Field> {
    return this.post('/fields', data);
  }
}

export const FieldsAPI = new FieldsHttpClient();
